import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'
import { PrefectureDropdownController } from './controllers/prefecture_dropdown_controller'
import { CityDropdownController } from './controllers/city_dropdown_controller'
import { SearchController } from './controllers/search_controller'

const app = Application.start()

app.register('refosumu--home-index--company-search-form', class extends Controller {
  static targets = ['prefectureInput', 'prefectureText', 'prefectureDropdown', 'cityInput', 'cityText', 'cityDropdown', 'cityButtonsContainer', 'partType']

  // ========================================
  // ライフサイクル
  // ========================================

  connect() {
    this.selectedPrefecture = null
    this.selectedCity = null
    this.selectedCityName = null
    this.cities = []

    // コントローラーの初期化
    this.prefectureDropdownController = new PrefectureDropdownController(this)
    this.cityDropdownController = new CityDropdownController(this)
    this.searchController = new SearchController(this)

    // ドロップダウンの外側クリックでクローズ（メモリリーク防止のため参照を保持）
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.boundHandleClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  handleClickOutside(event) {
    // クリックされた要素がドロップダウンボタンまたはドロップダウン内かどうかを確認
    const isPrefectureInput = event.target.closest('[data-refosumu--home-index--company-search-form-target="prefectureInput"]')
    const isPrefectureDropdown = event.target.closest('[data-refosumu--home-index--company-search-form-target="prefectureDropdown"]')
    const isCityInput = event.target.closest('[data-refosumu--home-index--company-search-form-target="cityInput"]')
    const isCityDropdown = event.target.closest('[data-refosumu--home-index--company-search-form-target="cityDropdown"]')

    // 都道府県ドロップダウン：ボタンとドロップダウン内以外のクリックで閉じる
    if (!isPrefectureInput && !isPrefectureDropdown) {
      this.prefectureDropdownController.closePrefectureDropdown()
    }

    // 市区町村ドロップダウン：ボタンとドロップダウン内以外のクリックで閉じる
    if (!isCityInput && !isCityDropdown) {
      this.cityDropdownController.closeCityDropdown()
    }
  }

  // ========================================
  // 都道府県ドロップダウン
  // ========================================

  togglePrefectureDropdown(event) {
    this.prefectureDropdownController.togglePrefectureDropdown(event)
  }

  selectPrefecture(event) {
    this.prefectureDropdownController.selectPrefecture(event)
  }

  // ========================================
  // 市区町村ドロップダウン
  // ========================================

  toggleCityDropdown(event) {
    this.cityDropdownController.toggleCityDropdown(event)
  }

  selectCity(event) {
    this.cityDropdownController.selectCity(event)
  }

  // ========================================
  // 検索処理
  // ========================================

  onSearchClick(event) {
    this.searchController.onSearchClick(event)
  }
})
